import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Grid, IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { useModal } from 'mui-modal-provider';
import * as React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useRegenerateIntegrationKey } from '../../../sic-lib/api/hooks/useIntegrations';
import { ApiIntegrationType } from '../../../sic-lib/enums/ApiIntegrationType';
import { splitCamelCase } from '../../../sic-lib/utils/aiHelpers';
import ButtonLoading from '../../Shared/ButtonLoading';
import DialogConfirmAction from '../../Shared/DialogConfirmAction/DialogConfirmAction';

interface Props {
    id: number;
    sourceKey: string;
    sourceId: ApiIntegrationType;
}

export default function IntegrationsTableItem({ id, sourceKey, sourceId }: Props) {
    const { showModal } = useModal();
    const [isCopied, setIsCopied] = React.useState<boolean>(false);

    const {
        mutate: regenerateMutation,
        isLoading: isRegenerateLoading,
        isSuccess: isRegenerateSuccess,
        isError: isRegenerateError,
    } = useRegenerateIntegrationKey();

    const handleConfirmHandler = () => {
        const modal = showModal(DialogConfirmAction, {
            title: `Confirm regenerate ${splitCamelCase(ApiIntegrationType[sourceId].toString())}`,
            description: `Regenerate a ${splitCamelCase(
                ApiIntegrationType[sourceId].toString(),
            )} may cause failure of getting leads this integration.`,
            onConfirm: () => regenerateMutation(sourceId),
            onCancel: () => {
                modal.hide();
            },
        });
    };

    const handleCopyKey = () => {
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 3000);
    };

    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row">
                {splitCamelCase(ApiIntegrationType[sourceId].toString())}
            </TableCell>
            <TableCell align="left">
                <Grid container direction="row" justifyContent="flex-start" alignItems="center">
                    <Typography variant="body2">{sourceKey}</Typography>
                    {sourceKey && (
                        <CopyToClipboard text={sourceKey || ''} onCopy={handleCopyKey}>
                            <Grid ml={2}>
                                <Tooltip
                                    title={isCopied ? 'Copied' : 'Copy Key To Clipboard'}
                                    placement="top"
                                >
                                    <IconButton aria-label="Copy" size="small">
                                        <ContentCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Grid>
                        </CopyToClipboard>
                    )}
                </Grid>
            </TableCell>
            <TableCell align="right">
                <ButtonLoading
                    isLoading={isRegenerateLoading}
                    onClick={handleConfirmHandler}
                    isSuccess={isRegenerateSuccess}
                    successLabel={'Regenerated'}
                    isError={isRegenerateError}
                >
                    {sourceKey ? 'Regenerate' : 'Generate'}
                </ButtonLoading>
            </TableCell>
        </TableRow>
    );
}
